export default __webpack_public_path__ + "static/media/bookingfinishloader.e94752fe.gif";